<section class="footer-section-2">
    <div class="footer-top">
        <div class="footer-main">
            
            <div class="logo-content-section">
                <div class="txt-container">
                    <a class="logo-block" href="index.html"><img src="assets/images/footer-logo.svg" alt="footer-logo"></a>
                </div>
                <p>{{'footer text' | translate}}</p>
            </div>

            <div class="gap-space"></div>
            
            <div class="sub-link-section">
                <div class="txt-container">
                    <ul>
                        <li *ngIf="isBusiness"> <a  routerLink="/dashboard"  class="hvr-efx1" [ngClass]="{ 'active': url == 'dashboard'}" >{{'Dashboard' | translate}}</a> </li>
                        <!-- <li *ngIf="isBusiness"><a *ngIf = "login == '1'" [ngClass]="{ 'active': url == 'employees'}" class="active" routerLink="/employees">{{'Employees' | translate}}</a></li>
                        <li *ngIf="isBusiness"><a  *ngIf = "login == '1'" routerLink="/cnss-reports">{{'DTS' | translate}} </a></li>
                        <li *ngIf="isBusiness"><a  *ngIf = "login == '1'" routerLink="/faq">{{'FAQ' | translate}} </a></li>

                        <li>
                        <a *ngIf = "login == '2'" routerLink="/dependence">{{'Dependence' | translate}}</a>
                        </li>
                        <li>
                        <a routerLink="/experience" *ngIf = "login == '2'" >{{'Experience' | translate}}</a>
                        </li>
                        <li>
                        <a  routerLink="/cnss"  *ngIf = "login == '2'" >{{'CNSS' | translate}}</a>
                        </li>
                        <li>
                        <a routerLink="/employee-cnamgs"  *ngIf = "login == '2'">{{'CNAMGS' | translate}}</a>
                        </li>
                        <li *ngIf="accountDetails && !isBusiness && login == '1'"><a routerLink="/link-business">{{'Link Business' | translate}}</a></li> -->
                    
                        <li><a  routerLink="/contact-us">{{'Contact' | translate}}</a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="footer-bottom">
        <div class="footer-bottom-container">
            <div class="left-txt">
                <p>{{"All rights reserved. 2026." | translate}}</p>
                <p>{{"Version 1.18" | translate}}</p>
            </div>

            <div class="right-txt">
                <!-- <p>{{"A product of" | translate}} <a href="https://clikafrikgroup.com/" target="_blank">{{"CLIKAFRIK" | translate}}</a></p> -->
            </div>
        </div>
    </div>
   
</section>